import { useLocalStorage } from '@/composables/useLocalStorage'
import { NavigationGuardWithThis } from 'vue-router'

const mobileOnboardingGuard: NavigationGuardWithThis<undefined> = async (
  _to,
  _from,
  next,
) => {
  const localStorage = useLocalStorage()
  const isOnboardingComplete =
    localStorage.getStorageItem<boolean>('welcomeComplete')

  if (!isOnboardingComplete) {
    await next({ name: 'welcome' })
  } else {
    await next()
  }
}

export default mobileOnboardingGuard
